import React, {useState,useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {envAction} from '../../../redux/envVariable/envAction'
import {appurl} from '../../../../url';
import axios from 'axios';
import './TrafficStatus.scss';

// import log from 'loglevel';
// import remote from 'loglevel-plugin-remote';

// const getCounter = () => {
//     let count = 1;
//     return () => count++;
// }

// const counter = getCounter();
// const customJson = (log:any) => ({
//     msg: log.message,
//     count:counter
// })

// const defaultOption = {
//     url: '/logger',
//     method: 'POST',
//     headers: {
//         'Content-Type':'application/json'
//     },
//     format:customJson
// }

// remote.apply(log,defaultOption);
// log.enableAll();
// log.error('error 1');
// log.error('error 2');

const TrafficStatus = () => {
    const [status, setStatus] = useState('');
    const [activeRegion,setActiveRegion] = useState('');
    const jwtIdToken = useSelector((state:any) => state.user.token);
    const dispatch = useDispatch()
    const getStatus = async () => {
        try {
            const response = await axios.get(appurl,{
                headers: {
                    'Authorization': jwtIdToken
                }
            })
            if(response.status === 200) {
                let data = response.data;
               
                let activeRegion = data.region.join(', ');
                setStatus(data.message);
                setActiveRegion(activeRegion);
                dispatch(envAction(data.env));
            } else {
                console.log('Server Issue')
            }
        }
        catch(e) {
            console.log(e);
           
        }
    }

    useEffect(()=>{
        getStatus();
        const interval:ReturnType<typeof setInterval> = setInterval(()=> {
            getStatus();
        },30000)

        return () => {
            clearInterval(interval)
        }
    },[])

    const reloadPage = () => {
        getStatus();
    }
    
    //console.log('status',status)
    return <div className='trafficStatus'>
    <div className='clearfix'>
        <div className='float-start'>
            <span className='blockTitle'>Traffic Status</span>
        </div>
        <div className='float-end'>
            <span className='fa fa-repeat reload' onClick={reloadPage}></span>
        </div>
    </div>
    <div className='clearfix'>
        <div className='float-start'>
            {
                status.length?
                <>
                    {
                        status.toLowerCase() === 'active-active'?
                        <div className='statusBadge activeStatus mt-3'>{status}</div>:
                        status.toLowerCase() === 'failover'?
                        <div className='statusBadge failoverStatus mt-3'>{status}</div>:
                        <div className='statusBadge disasterRecovery mt-3'>{status}</div>

                    }
                </>:
                <div className='nodata'>No Data Available</div>
            }
        </div>
        <div className='float-end'>
            <p className='regionInfo'>{activeRegion}</p>
        </div>
    </div>
    
</div>
}

export default TrafficStatus;